

import { reviveDateTime } from "../../common/utils/date-utils";
import { setCount } from "../../redux/notification-slice";
import { store } from "../../redux/store";
import { JwtAuthService } from "../authentication/jwt-auth.service";
import { SocketService } from "./socket.service";



let notificationSocketInitialized = false;

export function notificationInitSockets() {



    if (!notificationSocketInitialized && JwtAuthService.isAuthenticated()) {
        notificationSocketInitialized = true;
        SocketService.getSocket("fbx", "fbx-ntf").then(_socket => {
            if (_socket) {
                _socket.off('fbx-ntf');
                _socket.on('fbx-ntf', async (data: any) => {
                    if (typeof data.timeStamp === 'string') {
                        data.timeStamp = reviveDateTime("timeStamp", data.timeStamp);
                    }
                    store.dispatch(setCount(data))
                });
            }
        })
    }
}

export function notificationResetSockets() {
    notificationSocketInitialized = false;
    SocketService.reset('fbx', 'fbx-ntf');
}

